import type { ReactNode } from "react";

import { GlassCard } from "./GlassCard";

interface SummaryCardProps {
  title: string;
  eyebrow?: string;
  description?: string;
  footer?: ReactNode;
  children?: ReactNode;
}

export function SummaryCard({ title, eyebrow, description, footer, children }: SummaryCardProps) {
  return (
    <GlassCard className="stack-md">
      {eyebrow ? <span className="card-eyebrow">{eyebrow}</span> : null}
      <div className="stack-xs">
        <h3 className="card-title">{title}</h3>
        {description ? <p className="card-copy">{description}</p> : null}
      </div>
      {children}
      {footer ? <div className="card-footer">{footer}</div> : null}
    </GlassCard>
  );
}
